<template>
  <!-- 二级菜单 -->
  <div
    ref="secondSideBarRef"
    class="absolute h-full transition-[width] duration-300 z-10"
    :class="isCollapse || isHover ? 'w-[260px]' : 'w-0'"
    @transitionend="(ev: any) => {if (!isCollapse) ev.target.removeAttribute('style');}"
  >
    <div class="w-full h-full overflow-hidden">
      <div
        class="w-full h-full border-gray-primary border-r-[0px] border-solid py-[24px] px-[16px] bg-[#020202] overflow-x-scroll narrow-scrollbar"
      >
        <div class="font-bold text-xl text-white mb-4 px-2 box-border">{{ routeTitle }}</div>
        <ul
          v-auto-animate
          class="w-full flex space-y-[16px] flex-col"
        >
          <SecondLevelSideBarItem
            v-for="(router, index) in secondRouter"
            :key="index"
            :index="index"
            :router="router"
            :active="activeRouter"
          />
        </ul>
      </div>
    </div>
    <!-- 展开/收缩菜单按钮 -->
    <!-- <div
      class="absolute top-0 bottom-0 right-[-9px] my-auto shadow-[0_3px_6px_0_rgba(0,0,0,.03)] flex justify-center items-center w-5 h-[60px] rounded-default bg-white-primary z-10 cursor-pointer border border-black-disabled border-solid box-border hover:shadow-[0_3px_6px_0_rgba(0,0,0,.1)] hover:border-brand"
      @click="collapseEvent()"
    >
      <svg-icon
        name="arrow"
        size="12"
        class="transition"
        :class="isCollapse || isHover ? 'rotate-[90deg]' : 'rotate-[-90deg]'"
      />
    </div> -->
  </div>
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouterStore } from '@/store/global/router.store';
import SecondLevelSideBarItem from '@/components/Layout/SecondLevelSideBarItem.vue';
import { useStorage } from '@vueuse/core';
import { SvgIcon } from '@tencent/aix-design';

const secondSideBarRef = ref(null);
const isCollapse = useStorage('aix-left-nav-collapse', false, localStorage);
const { firstRoute, secondRouter } = storeToRefs(useRouterStore());
const { setFirstRoute } = useRouterStore();
const currentRoute = useRoute();

defineProps({
  isHover: {
    type: Boolean,
    default: false,
  },
});

// 根据路径来确定默认的active router
const activeRouter = ref<string>('');

const collapseEvent = () => {
  setFirstRoute(currentRoute.matched[0]);
  isCollapse.value = !isCollapse.value;

  if (isCollapse.value) {
    (secondSideBarRef.value as unknown as HTMLDivElement).style.position = 'relative';
  }
};

onMounted(() => {
  if (isCollapse.value) {
    (secondSideBarRef.value as unknown as HTMLDivElement).style.position = 'relative';
  }
});

const routeTitle = ref<string>('');
watch([() => currentRoute?.matched, () => secondRouter.value], ([currentRoute, secondRouter]) => {
  routeTitle.value = (firstRoute?.value?.meta.title || firstRoute?.value?.meta.name) as string;

  activeRouter.value = (secondRouter.find((r) => r.name === currentRoute?.[1]?.name)?.name as string) || '';
});

const showSecondSideBar = computed(() => true);

defineExpose({ showSecondSideBar });
</script>
<style scoped>
.absolute_ {
  position: absolute;
}

.nav-item {
  @apply w-[100%] h-[32px] flex items-center px-[8px] py-[4px] select-none rounded-default;
}

.nav-item:hover {
  @apply bg-white-secondary;
}

.router-link-active {
  @apply rounded-default bg-white-primary;
}
</style>
